
import { Component, EventEmitter, forwardRef, Input, LOCALE_ID, Output, inject } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { typeGuardPartial } from '../../core/utils/partial';


@Component({
    selector: 'app-year-month-picker',
    templateUrl: './year-month-picker.component.html',
    styleUrls: ['./year-month-picker.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => YearMonthPickerComponent),
            multi: true
        }],
    standalone: false
})
export class YearMonthPickerComponent implements ControlValueAccessor {

  @Input() value: YearMonthEntry | undefined;
  @Input()
  set minYear(minYear: number) {
    this.internalMinYear = minYear;
    const thisYear = new Date().getFullYear();
    this.years = [];
    this.years.push(thisYear);
    const diff = thisYear - minYear;
    if (diff >= 0 && diff < 100) {
      for (let index = (thisYear - 1); index >= minYear; index--) {
        this.years.push(index);
      }
    }

  }
  get minYear(): number {
    return this.internalMinYear;
  }

  @Input() placeholder = '';

  @Output() changed = new EventEmitter<YearMonthEntry | undefined>();

  years: number[] = [];
  readonly months: number[] = [];

  monthNames: readonly string[];

  parts: FormGroup<{ year: FormControl<number>; month: FormControl<number>; }>;

  private internalMinYear = new Date().getFullYear();

  constructor() {
    const locale = inject(LOCALE_ID);
    const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });

    this.monthNames = Array.from({ length: 12 }, (_, i) =>
      monthFormatter.format(new Date(2000, i))
    );
    for (let index = 1; index <= 12; index++) {
      this.months.push(index);
    }

    const fb = new FormBuilder().nonNullable;

    const today = new Date();
    this.years.push(today.getFullYear());

    this.parts = fb.group({
      year: fb.control(this.years[0], Validators.required),
      month: fb.control(today.getMonth(), Validators.required),
    });

    this.parts.valueChanges.subscribe(_val => {
      this.updateValue();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = (_value: unknown) => { };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {
  };

  writeValue(value: YearMonthEntry) {
    this.parts.setValue(value);
  }
  registerOnChange(fn: (v: unknown) => void) {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  private updateValue() {
    this.value = this.readValueFromUI();
    this.onChange(this.value);
  }

  readValueFromUI(): YearMonthEntry | undefined {
    const value = this.parts.value;
    return partialIsYearMonthEntry(value) ? value : undefined;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.parts.disable();
    } else {
      this.parts.enable();
    }
  }

}

export interface YearMonthEntry {
  year: number;
  month: number;
}

export const partialIsYearMonthEntry = typeGuardPartial<YearMonthEntry>('year', 'month');





